import { Avatar, Button, Divider, Snackbar, Typography } from "@material-ui/core";
import Check from "@material-ui/icons/Check";
import Footer from "~/components/common/footerContainer/FooterContainer";
import TitleContainer from "~/components/common/titleContainer/TitleContainer";
import StickyFooter from "~/components/common/stickyFooter/StickyFooter";
import { scheduleOnGoogleCalendar } from "~/utils/GoogleCalendar/GoogleCalendar";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { withRouter, useParams } from "react-router-dom";
import _ from "lodash";
import { useSelector } from "react-redux";
import businessService from "~/services/businessService";
import bookingTransactionService from "~/services/bookingTransactionService";
import dayjs from "~/config/dayjs";

import useDateFormatter from "../../hooks/useDateFormatter";
import useStyles from "./style";
import Utils from "../../helpers/Utils";
import { getInitials, getAvatarFontSize, formatPhoneNumber, handleAddress } from "~/utils/business";
import { mixpanelTrackEvent } from "~/utils/mixpanel";
import useCheckSessionPackage from "~/hooks/useCheckSessionPackage";
import PackagePaymentSummary from "../common/paymentSummaryPackage/PaymentSummary";
import PaymentSummary from "../common/paymentSummary";
import ServiceItem from "../common/serviceItem/ServiceItem";

import LinhaPacote from "~/components/common/linhaPacote/LinhaPacote";
import { formatDateDDMMYYYY } from "~/utils/packages";

// Tokens do protótipo para a linha de serviço com pacote
const INK = "#2B2B30";
const MUT = "#8A8A90";
const LIN = "#EDEDE6";

// Serviço pago com pacote (sessão usada ou pacote comprado agora):
// nome + preço riscado, data/duração/profissional e o card do pacote com o saldo atualizado.
const PackageServiceRow = ({ name, price, detailLine, pacote, currency, businessColor, hideDivider }) => (
	<div style={{ padding: "14px 0", borderBottom: hideDivider ? "none" : `1px solid ${LIN}` }}>
		<div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 12 }}>
			<Typography translate="no" style={{ fontSize: 14.5, fontWeight: 700, color: INK, lineHeight: 1.3 }}>
				{name}
			</Typography>
			{price != null && (
				<Typography
					translate="no"
					style={{ fontSize: 14.5, fontWeight: 800, color: "#A6A6AC", textDecoration: "line-through", whiteSpace: "nowrap" }}>
					{Utils.formatMoney(price / 100, currency)}
				</Typography>
			)}
		</div>
		{detailLine && (
			<Typography style={{ fontSize: 12.5, color: MUT, marginTop: 6 }}>
				{detailLine}
			</Typography>
		)}
		<div style={{ marginTop: 12 }}>
			<LinhaPacote
				nome={pacote.nome}
				total={pacote.total}
				feitas={pacote.feitas}
				valeAte={pacote.valeAte}
				aberto={false}
				card={true}
				businessColor={businessColor}
			/>
		</div>
	</div>
);


const DialogScheduleConfirm = (props) => {
	let { business } = useSelector((store) => store.business);
	const { user } = useSelector((store) => store.auth);
	const [payload, setPayload] = useState(props?.location?.state?.payload);
	const me = Utils.safeParseJSON("@prit-web/meData");
	const currentUser = me || user || {};

	// Dados do checkout passados via props
	const checkoutInformation = props?.location?.state?.checkout;
	const checkoutInformationPackage = props?.location?.state?.checkoutInformationPackage;
	const selectedPackages = props?.location?.state?.selectedPackages || [];
	const infoPackage = props?.location?.state?.infoPackage || null;
	// O checkout manda o state da rota em `payload` — é ali que vêm as escolhas de pacote
	const packageChoices =
		props?.location?.state?.packageChoices || props?.location?.state?.payload?.packageChoices || {};
	const singleServices = props?.location?.state?.singleServices || props?.location?.state?.payload?.services || payload?.services || [];
	const couponValue = props?.location?.state?.couponValue;
	const totalPricingType = props?.location?.state?.totalPricingType;
	const currency = business?.currency;
	const offerAccepted = props?.location?.state?.offerAccepted;
	const { sessionsAccepted, } = useCheckSessionPackage();

	const { id, bookingTransactionId } = useParams();

	const payment_intent = new URLSearchParams(props.location?.search).get("payment_intent");
	const payment_intent_client_secret = new URLSearchParams(props.location?.search).get("payment_intent_client_secret");
	const redirect_status = new URLSearchParams(props.location?.search).get("redirect_status");

	const isForeignCheckout = payment_intent && payment_intent_client_secret && redirect_status;

	const classes = useStyles({ me });
	const { t, i18n } = useTranslation();
	const { formatTime, formatDateToLanguage } = useDateFormatter();
	const formatDateByLanguage = formatDateToLanguage();
	const [isAnimating, setIsAnimating] = useState(false);
	const [copiedLink, setCopiedLink] = useState(false);

	const handleCopyLink = async () => {
		const url = `${process.env.REACT_APP_URL}/${business?.slug || business?.id}`;
		try {
			await navigator.clipboard.writeText(url);
			setCopiedLink(true);
		} catch (e) {
			console.error("Failed to copy link", e);
		}
	};

	useEffect(() => {
		// Inicia as animações quando o componente monta
		setIsAnimating(true);
	}, []);

	const getServiceName = (item) => {
		if (i18n.language === "en-US") {
			return item.nameEng;
		} else if (i18n.language === "es-ES") {
			return item.nameEsp;
		} else {
			return item.name;
		}
	};

	const getBusiness = async () => {
		await businessService.getBusiness(id).then(({ data }) => {
			business = data;
		});
	};

	const goToReservations = () => {
		try {
			mixpanelTrackEvent("Clickou_Ver_Meus_Agendamentos_Checkout", {}, currentUser, business);
			props.history.push("/reservas");
		} catch (error) {
			console.error("Error navigating to reservations:", error);
		}
	}

	const getBookingTransaction = async () => {
		await bookingTransactionService.getOneBookingTransaction(bookingTransactionId).then((res) => {
			const booking = res.data.bookings[0];
			const service = booking.service;
			const services = [
				{
					date: booking.startTime,
					dateStart: booking.startTime,
					service_id: service?.id,
					professional_id: booking.professional?.id,
					service: {
						serviceName: getServiceName(service),
						servicePrice: service?.price,
						serviceDuration: service?.duration || booking.duration,
					},
					professional: {
						id: booking.professional?.id,
						name: booking.professional?.name,
						avatarUrl: booking.professional?.avatarUrl,
						price: booking.price ?? service?.price,
						pricingType: booking.pricingType?.namePort || booking.pricingType?.name,
					},
				},
			];
			setPayload({
				services: services,
			});
		});
	};

	const checkoutPayload = localStorage.getItem("@prit-web/checkoutPayload");

	if (checkoutPayload) {
		localStorage.removeItem("@prit-web/checkoutPayload");
	}

	useEffect(() => {
		const onPopState = () => {
			props.history.go(1);
		};
	
		window.history.pushState(null, "", window.location.href);
		window.addEventListener("popstate", onPopState);
	
		const unlisten = props.history.listen((_, action) => {
			if (action === "POP") {
				props.history.go(1);
			}
		});
	
		return () => {
			window.removeEventListener("popstate", onPopState);
			if (unlisten) unlisten();
		};
	}, []);

	useEffect(() => {
		window.scrollTo(0, 0);
		if (isForeignCheckout) {
			if (_.isUndefined(business)) {
				getBusiness();
			}

			if (_.isUndefined(payload)) {
				getBookingTransaction();
			}
		} else if (props?.location?.state?.fromCheckSlot && bookingTransactionId && _.isUndefined(payload)) {
			getBookingTransaction();
		}
	}, []);

	useEffect(() => {
		if (business && payload && payload?.services?.length > 0) {
			payload.services.forEach((service) => {
				let event = {
					name: service.service.serviceName,
					business: {
						addressStreet: business.address.street,
						timeZone: business.timeZone,
					},
					startTime: new Date(new Date(service.date).getTime() + 10800000).toJSON(),
					endTime: new Date(
						new Date(service.date).getTime() + 10800000 + service.service.serviceDuration * 60000
					).toJSON(),
				};
				scheduleOnGoogleCalendar(event, business.name);
			});
		}
	}, [payload]);

	const handleLinkIndicator = () => {
		props.history.push("/indicacoes");
	};

	const handleReferProfessional = () => {
		// Implementar lógica para indicar profissional
		window.location =
			"https://prit-business.onelink.me/Mxb0?pid=User_invite&deep_link_value=7adcafc1e674209531794a6ebf6b5db7";
	};

	const handleProfessionalPrit = () => {
		// Implementar lógica para profissionais
		window.location =
			"https://prit-business.onelink.me/Mxb0?pid=User_invite&deep_link_value=7adcafc1e674209531794a6ebf6b5db7";
	};

	const handleViewOnMap = () => {
		if (business?.address?.latitude && business?.address?.longitude) {
			const url = `https://www.google.com/maps?q=${business.address.latitude},${business.address.longitude}`;
			window.open(url, "_blank");
		} else if (business?.address?.street) {
			const { street, number, unit, postalCode } = business?.address;
			const address = [street, number, postalCode]
				.filter((part) => part != null && String(part).trim() !== "")
				.join(", ");
			const encodedAddress = encodeURIComponent(address);
			const url = `https://www.google.com/maps/search/${encodedAddress}`;
			window.open(url, "_blank");
		}
	};

	const sanitizePhone = (phone) => {
		if (!phone) return "";
		return String(phone).replace(/[^\d+]/g, "");
	};

	const handleCopyPhone = async () => {
		const phone = sanitizePhone(business?.phone);
		if (!phone) return;
		try {
			await navigator.clipboard.writeText(phone);
		} catch (e) {
			console.error("Failed to copy phone", e);
		}
	};

	const renderDetailLine = (dateIso, durationMinutes, professionalName) => {
		const when = dateIso ? dayjs(dateIso).utc().tz(business?.timeZone) : null;
		const date = when ? when.format(formatDateToLanguage().dayMonth) : "";
		const time = when ? formatTime(when.format("HH:mm")) : "";
		const duration = durationMinutes ? Utils.formatMinutes(durationMinutes).trim() : "";
		const parts = [date && time ? t("checkout_review_date_time", { date, time }) : "", duration, professionalName || ""].filter(Boolean);
		return parts.join(" · ");
	};

	// Uma lista só, na ordem do agendamento: avulsos, serviços com sessão de pacote
	// usada e, por último, os serviços cujo pacote foi comprado agora.
	const confirmationRows = [
		...(singleServices || []).map((service) => {
			const session = (sessionsAccepted || []).find((s) => s.serviceId === service.service_id);
			const choice = packageChoices[service?.service_id];
			const detailLine = renderDetailLine(
				service?.dateStart || service?.date,
				service?.professional?.duration || service?.service?.serviceDuration,
				service?.professional?.name
			);
			const price = service?.professional?.price ?? service?.service?.servicePrice ?? null;
			const name = service?.service?.serviceName || service?.service?.name;

			if (session) {
				const total = Number(session.infoPackage?.packageQuantity) || 0;
				const remaining = Number(session.infoPackage?.packageRemainding) || 0;
				return {
					type: "package",
					name,
					price,
					detailLine,
					// a sessão deste agendamento já foi consumida
					pacote: {
						nome: session.infoPackage?.packageName || "",
						total,
						feitas: Math.min(total, total - remaining + 1),
						valeAte: session.infoPackage?.packageExpiry || null,
					},
				};
			}
			if (choice?.type === "client" && choice.display) {
				return {
					type: "package",
					name,
					price,
					detailLine,
					pacote: { ...choice.display, feitas: (choice.display.feitas || 0) + 1 },
				};
			}
			return { type: "single", service };
		}),
		...selectedPackages.map((pkgData) => {
			const checkoutService = pkgData.checkoutService;
			const linked = pkgData.serviceLinkedPackage;
			const total = pkgData.info?.quantity || 0;
			const validity = pkgData.info?.validity;
			return {
				type: "package",
				name: pkgData.info?.serviceName || checkoutService?.service?.serviceName,
				price: checkoutService?.service?.servicePrice ?? linked?.service?.price ?? null,
				detailLine: renderDetailLine(
					checkoutService?.date || pkgData.serviceDateTime?.start_time,
					checkoutService?.professional?.duration || pkgData.info?.duration || linked?.professional?.duration,
					checkoutService?.professional?.name || linked?.professional?.name
				),
				// pacote comprado agora: este agendamento é o primeiro atendimento
				pacote: {
					nome: pkgData.info?.packageName || "",
					total,
					feitas: 1,
					valeAte: validity ? formatDateDDMMYYYY(dayjs().add(validity, "day").toISOString(), i18n.language) : null,
				},
			};
		}),
	];
	const singleRows = confirmationRows.filter((row) => row.type === "single");

	return (
		<>
		<div className={isAnimating ? classes.animatedBackgroundFadeOut : ''}>
			<TitleContainer
				headerClassName={isAnimating ? classes.animatedTopFadeOut : ''}
			>
				{/* Success header */}
				<div
					className={`${classes.successHeader} ${isAnimating ? classes.animatedSlideUp : ''}`}
					style={isAnimating ? { opacity: 0 } : {}}
				>
					<div className={classes.successIconContainer}>
						<Check className={classes.successIcon} />
					</div>
					<Typography className={classes.successTitle}>{t("Appointment Scheduled")}</Typography>
				</div>

				<div
					className={isAnimating ? classes.animatedContentFadeIn : ''}
					style={isAnimating ? { opacity: 0 } : {}}
				>
					{/* Business section */}
					<div style={{ display: "flex", alignItems: "center", padding: "20px 20px 18px", gap: 16 }}>
						<Avatar
							variant="circle"
							src={business?.thumbnailUrl ? business.thumbnailUrl : ""}
							className={classes.headerAvatar}
							style={{ width: 56, height: 56, flexShrink: 0 }}
						>
							<Typography style={{ fontSize: getAvatarFontSize(business?.name) }}>
								{getInitials(business?.name)}
							</Typography>
						</Avatar>
						<div>
							<Typography style={{ fontSize: 16, fontWeight: 700, color: "#222", lineHeight: 1.3 }}>
								{business?.name}
							</Typography>
							{business?.address?.street && (
								<Typography style={{ fontSize: 13, color: "#666", marginTop: 4, lineHeight: 1.4 }}>
									{handleAddress(business)}
								</Typography>
							)}
							{business?.phone && (
								<Typography style={{ fontSize: 13, color: "#666", marginTop: 4 }}>
									{formatPhoneNumber(business.phone)}
								</Typography>
							)}
						</div>
					</div>

					<Divider style={{ margin: "0 20px" }} />

					{/* Services */}
					<div style={{ padding: "14px 20px 0" }}>
						{confirmationRows.map((row, index) => {
							const isLast = index === confirmationRows.length - 1;
							const packageSummaryFollows = selectedPackages.length > 0 && checkoutInformationPackage;
							if (row.type === "package") {
								return (
									<PackageServiceRow
										key={`package-${index}`}
										name={row.name}
										price={row.price}
										detailLine={row.detailLine}
										pacote={row.pacote}
										currency={currency}
										businessColor={business?.primaryColor}
										hideDivider={isLast && packageSummaryFollows}
									/>
								);
							}
							// a linha de pacote termina na própria borda: mesmo respiro do padding dela
							const followsPackageRow = confirmationRows[index - 1]?.type === "package";
							return (
								<div key={`single-${index}`} style={followsPackageRow ? { paddingTop: 14 } : undefined}>
									<ServiceItem
										service={row.service}
										index={singleRows.indexOf(row)}
										totalServices={singleRows.length}
										checkoutInformation={checkoutInformation}
										currency={currency}
										viewUponConsultation={true}
										showDivider={!isLast}
									/>
								</div>
							);
						})}
					</div>

					{/* Payment summary */}
					{selectedPackages.length > 0 && checkoutInformationPackage ? (
						<>
							{/* o PackagePaymentSummary já abre com a própria divisória */}
							<div style={{ padding: "0 20px" }}>
								<PackagePaymentSummary
									checkoutInformationPackage={checkoutInformationPackage}
									checkoutInformation={checkoutInformation}
									currency={currency}
									singleServices={singleServices}
									selectedPackages={selectedPackages}
								/>
							</div>
						</>
					) : (
						checkoutInformation && !(sessionsAccepted?.length > 0) && singleRows.length > 0 && (
							<>
								{checkoutInformation?.anticipation_payment > 0 && <Divider style={{ margin: "16px 20px 0" }} />}
								<div style={{ padding: "0 20px" }}>
									<PaymentSummary
										checkoutInformation={checkoutInformation}
										payload={payload}
										couponValue={couponValue}
										totalPricingType={totalPricingType}
										currency={currency}
									/>
								</div>
							</>
						)
					)}

					{/* Cancellation policy */}
					{checkoutInformation?.use_cancellation_policy && (
						<div style={{ padding: "0 20px" }}>
							<div style={{ marginTop: 20 }}>
								<Typography className={classes.cancellationPolicy}>{t("Cancellation policy")}:</Typography>
								<Typography className={classes.cancellationText}>
									{Utils.policyDetails(checkoutInformation, currency, t)}
								</Typography>
							</div>
							<Divider className={classes.divider} />
						</div>
					)}

					{/* Agendamento feito pelo Prit — só texto; o botão fica fixo no rodapé */}
					<div style={{ padding: "20px 28px 170px", textAlign: "center" }}>
						<Typography style={{ fontSize: 12.5, color: MUT, lineHeight: 1.5 }}>
							{`${t("Appointment made prit title")}. ${t("Appointment made prit subtitle")}`}
						</Typography>
						{(business?.slug || business?.id) && (
							<Typography
								onClick={() => window.open(`${process.env.REACT_APP_URL}/${business?.slug || business?.id}`, "_blank")}
								style={{ fontSize: 12.5, color: "#6B6B72", lineHeight: 1.5, marginTop: 8, cursor: "pointer", textDecoration: "underline" }}>
								{`${process.env.REACT_APP_URL}/${business?.slug || business?.id}`}
							</Typography>
						)}
					</div>
				</div>
			</TitleContainer>
			<Snackbar
				open={copiedLink}
				autoHideDuration={2000}
				onClose={() => setCopiedLink(false)}
				message={t("Link copied!")}
				anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
			/>
		</div>
		{/* Fora do container animado: ele termina em opacidade 0.8 e apagaria o botão */}
		<StickyFooter showFooter={true}>
			<div style={{ padding: "10px 18px 12px" }}>
				<Button onClick={() => goToReservations()} className={classes.primaryButton} style={{ padding: "12px 20px" }}>
					{t("View my schedules")}
				</Button>
			</div>
			<Footer />
		</StickyFooter>
		</>
	);
};

export default withRouter(DialogScheduleConfirm);
